import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";
import StringUtils from "utilities/string-utils";
interface UsePageActivateBlockQueryParamsArgs {
    areBlocksLoaded: boolean;
    isInEditMode: boolean;
    onActiveBlockChange: (blockId: number) => Promise<void>;
}
export interface PageActiveBlockQueryParams {
    activeBlock: string;
    [key: string]: string;
}

export const usePageActivateBlockQueryParams = ({
    areBlocksLoaded,
    isInEditMode,
    onActiveBlockChange,
}: UsePageActivateBlockQueryParamsArgs) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    useEffect(() => {
        const activateBlockAndClearParam = async () => {
            const { activeBlockId = "", ...otherParams } =
                RouteUtils.queryStringToObject<PageActiveBlockQueryParams>(
                    search
                );
            if (
                isInEditMode &&
                StringUtils.hasValue(activeBlockId) &&
                areBlocksLoaded
            ) {
                const activeBlockIdAsNumber = parseInt(activeBlockId);
                if (activeBlockIdAsNumber) {
                    await onActiveBlockChange(activeBlockIdAsNumber);
                }
                replace(
                    RouteUtils.appendQueryParams(pathname, {
                        ...otherParams,
                    })
                );
            }
        };

        activateBlockAndClearParam();
    }, [
        areBlocksLoaded,
        isInEditMode,
        onActiveBlockChange,
        pathname,
        replace,
        search,
    ]);
};
